import {Component, input} from '@angular/core';
import {SummaryCardComponent} from '../../../../../../../../../shared/components/card/summary-card/summary-card.component';
import {TotalFeeData} from '../../total-fees/total-fees.types';
import {AppCurrencyPipe} from '@frontend/shared';

@Component({
  selector: 'app-total-fee-card',
  templateUrl: './total-fee-card.component.html',
  imports: [SummaryCardComponent, AppCurrencyPipe],
  host: {
    class: 'flex-1',
  },
})
export class TotalFeeCardComponent {
  readonly totalFeeCard = input.required<TotalFeeData>();
}
